import { Button } from "@mui/material";
import { excelExport } from "../../utilities/excel-export";

export const Excelpoc = () => {
  const data = [
    { Name: "n1", id: "1" },
    { Name: "n2", id: "2" },
    { Name: "n3", id: "3" },
  ];
  const onClick = () => {
    excelExport(data, "test");
  };

  return (
    <div>
      <Button
        variant="outlined"
        type="reset"
        sx={{ width: 100 }}
        onClick={onClick}
      >
        Download
      </Button>
    </div>
  );
};
